<template>
    <v-list id="account-switch-container">
        <v-list-item v-for="activeAccount in activeAccounts" :key="activeAccount.id"
                     @click="onAccountSwitch(activeAccount.id)"
        >
            <span class="organization-name mr-3" :class="{ active: activeAccount.id == account.id }">
                {{ activeAccount.organization.name }}
            </span>
            <NotificationsCounter :notifications="notifications(activeAccount.organization.id).length"  />
        </v-list-item>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import NotificationsCounter from "@/components/app/notifications/Counter";

export default {
    components: { NotificationsCounter },
    computed: {
        ...mapState("User", ["account"]),
        ...mapGetters("Notifications", {
            notifications: 'notificationsOfOrganization'
        }),
        activeAccounts() {
            let accounts = this.$store.getters['User/activeAccounts'];
            return accounts.filter(account => account.organization && !account.suspended_at);
        },
    },
    methods: {
        onAccountSwitch(id) {
            if (id == this.account.id) return;

            this.$store.dispatch("User/switchAccount", id);
        },
    },
};
</script>

<style lang="scss">
#account-switch-container.v-list {
    background: var(--dark-gray);
    padding: 25px 0;
    border-radius: var(--box-rounding);
    padding: 0;

    .v-list-item {
        display: flex;
        min-height: 24px;
        padding: 0 25px;
        font-size: 12px;

        .organization-name {
            color: #989898;
            line-height: 2;

            &.active {
                color: var(--primary);
            }
        }

        .notification-counter {
            margin-left: auto;
        }
    }
}
</style>
